import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// (tagContainer) are preserved — the factory returns them closed over the
// theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    pageViewContainer: {
      marginBottom: 16,
      marginTop: 16,
      marginHorizontal: 24,
    },
    paddingBottom24: {
      paddingBottom: 24,
    },
    marginTop16: {
      marginTop: 16,
    },
    marginHorizontal24: {
      marginHorizontal: 24,
    },
    tagContainer: index => ({
      padding: 8,
      borderRadius: 8,
      backgroundColor: colors.surface,
      marginLeft: index == 0 ? 0 : 16,
    }),
    flex1: {
      flex: 1,
    },
    emptyListContainer: {
      marginTop: 100,
      marginBottom: 50,
      alignItems: 'center',
    },
    flexRow: {
      flexDirection: 'row',
    },
    hitSlop: {
      top: 8,
      bottom: 8,
      left: 8,
      right: 8,
    },
    mhMinus24: {
      marginHorizontal: -24,
    },
  });

export default makeStyles;
